import script from "./addCoupons.vue?vue&type=script&setup=true&lang=js"
export * from "./addCoupons.vue?vue&type=script&setup=true&lang=js"

import "./addCoupons.vue?vue&type=style&index=0&id=969c8524&lang=scss&scoped=true"

import exportComponent from "D:\\yunchi\\yc\\yc-vue-source\\new-energy\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-969c8524"]])

export default __exports__